import { ArrowRightOutlined, RobotOutlined, ExpandAltOutlined } from '@ant-design/icons';
import { Card, Input, Button } from 'antd';
import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';

const StyledCard = styled(Card)`
    position: relative;
    overflow: hidden;
    border: 0;
    border-radius: 16px;
    background: var(--gradient-assistant);
    box-shadow: 0 8px 24px -4px hsl(262 60% 50% / 0.12);
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
        box-shadow: 0 12px 32px -4px hsl(262 60% 50% / 0.2);
    }

    .ant-card-body {
        border-radius: 16px;
        padding: 24px;
        display: flex;
        flex-direction: column;
        height: 100%;
        min-height: 180px;

        @media (max-width: 768px) {
            padding: 16px;
            min-height: 160px;
        }

        @media (max-width: 480px) {
            padding: 12px;
            min-height: 140px;
        }
    }
`;

export default StyledCard;

export const AskAsperCard = () => {
    const navigate = useNavigate();
    return (
        <StyledCard
            className="relative overflow-hidden border-0 shadow-none w-full"
            onClick={() => navigate('/ask-asper')}
        >
            <ExpandAltOutlined className="absolute top-4 right-4 md:top-6 md:right-6 text-gray-500 hover:text-gray-900 transition-colors z-10 text-sm md:text-base cursor-pointer" />

            <div
                className="absolute top-0 right-0 w-32 h-32 md:w-40 md:h-40 rounded-full blur-3xl"
                style={{ background: 'hsl(280 70% 65% / 0.15)' }}
            />
            <div
                className="absolute bottom-0 left-0 w-24 h-24 md:w-32 md:h-32 rounded-full blur-3xl"
                style={{ background: 'hsl(200 70% 65% / 0.15)' }}
            />

            <div className="relative flex items-start gap-3 md:gap-4 mb-auto">
                <div
                    className="flex h-10 w-10 md:h-12 md:w-12 items-center justify-center rounded-xl shrink-0"
                    style={{
                        background:
                            'linear-gradient(to bottom right, rgba(168, 85, 247, 0.1), rgba(139, 92, 246, 0.1))',
                        backdropFilter: 'blur(8px)',
                    }}
                >
                    <RobotOutlined className="text-lg md:text-2xl" style={{ color: 'hsl(262 60% 50%)' }} />
                </div>

                {/* Text Content */}
                <div className="flex-1 min-w-0">
                    <p className="text-sm md:text-base font-medium text-gray-900 leading-relaxed">
                        👋 Hello! I am{' '}
                        <span
                            className="font-semibold bg-clip-text text-transparent"
                            style={{
                                backgroundImage: 'linear-gradient(to right, hsl(262 60% 50%), hsl(280 60% 60%))',
                            }}
                        >
                            AskAsper
                        </span>
                        , your Knowledge Assistant 🤖
                    </p>
                    <p className="text-xs md:text-sm text-muted-foreground mt-1">
                        Ask me anything about RGM tools, insights, or how to get started
                    </p>
                </div>
            </div>

            <div className="relative flex gap-2 mt-auto">
                <Input
                    placeholder="💬 Type your question here..."
                    className="flex-1 shadow-sm hover:shadow-md transition-shadow text-sm md:text-base"
                    style={{
                        borderRadius: '8px',
                        border: '1px solid rgba(168, 85, 247, 0.1)',
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        backdropFilter: 'blur(8px)',
                    }}
                />
                <Button
                    type="primary"
                    shape="circle"
                    icon={<ArrowRightOutlined />}
                    className="shrink-0 shadow-md hover:shadow-lg transition-all h-8 w-8 md:h-10 md:w-10 flex items-center justify-center"
                    style={{
                        background: 'linear-gradient(135deg, hsl(262 60% 50%), hsl(280 60% 60%))',
                        border: 'none',
                    }}
                />
            </div>
        </StyledCard>
    );
};
